export default "__VITE_ASSET__wQkru25Y__"